@import (reference) '../../../constants/spacing.module.less';

.sortable-section {
  position: relative;

  &.draggable-mode {
    cursor: grab;
    border: 2px dashed var(--blue-300);
    border-radius: 8px;
    background-color: var(--blue-50);
    padding: @space-8;
    margin-bottom: @space-12;
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--blue-400);
      background-color: var(--blue-100);
    }

    &:active {
      cursor: grabbing;
    }
  }
}

.sortable-section-content {
  &.non-interactable {
    pointer-events: none;
    user-select: none;
    opacity: 0.85;
  }
}
